<template>
    <div class="seasonality-template-settings px-3 mt-3" v-if="!isEmpty(formData)">
        <label class="d-block mb-3">
            <span class="d-inline-block mb-3">Default Seasonality Template:</span>
            <b-row>
                <b-col cols="12" sm="8" md="6" lg="3">
                    <b-form-select
                        v-model="formData.template.id"
                        :options="options"
                        text-field="name"
                        value-field="id"
                        @change="onFormUpdated"
                    ></b-form-select>
                </b-col>
            </b-row>
        </label>
        <b-form-group>
            <form-square-switch
                class="settings-switch"
                :value="formData.use_per_person_rates"
                :sync="true"
                @input="togglePerPersonRates"
                :labels="{
                    checked: 'ON',
                    unchecked: 'OFF',
                }"
                :color="{
                    unchecked: 'rgba(0,0,0,.6)',
                }"
            />               
            <label>Display Per Person Rates</label>
        </b-form-group>
        <b-form-group>
            <form-square-switch
                class="settings-switch"
                :value="formData.arrival_day_rule_enabled"
                :sync="true"
                @input="toggleArrivalDayRules"
                :labels="{
                    checked: 'ON',
                    unchecked: 'OFF',
                }"
                :color="{
                    unchecked: 'rgba(0,0,0,.6)',
                }"
            />               
            <label>Display Arrival Day Rules</label>
        </b-form-group>
        <b-form-group>
            <form-square-switch
                class="settings-switch"
                :value="formData.departure_day_rule_enabled"
                :sync="true"
                @input="toggleDepartureDayRules"
                :labels="{
                    checked: 'ON',
                    unchecked: 'OFF',
                }"
                :color="{
                    unchecked: 'rgba(0,0,0,.6)',
                }"
            />   
            <label>Display Departure Day Rules</label>
        </b-form-group>
     
    </div>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import { templatesMixin } from '../mixins/templates-mixin';
    import FormSwitch from '../../generic/form-switch/form-switch.vue';
    import FormSquareSwitch from "../../generic/form-square-switch/form-square-switch.vue";
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'SeasonalitytemplatesData',
        components: {
            FormSwitch,
            FormSquareSwitch,
        },
        data() {
            return {
                formData: {},
            };
        },
        mixins: [templatesMixin],
        mounted() {
            this.fetchTemplatesData();
            this.fetchTemplates(false);
        },
        methods: {
            isEmpty,
            ...mapActions('seasonality', ['updateSettings']),
            async onFormUpdated() {
                try {
                    this.busy = true;
                    const payload = {
                        use_per_person_rates: this.formData.use_per_person_rates,
                        arrival_day_rule_enabled: this.formData.arrival_day_rule_enabled,
                        departure_day_rule_enabled: this.formData.departure_day_rule_enabled,
                        template: this.formData.template.id === -1 ? null : this.formData.template.id,
                    };
                    await this.updateSettings(payload);
                    this.successToast({
                        text: 'Settings updated successfully',
                    });
                } catch (err) {
                    this.errorToast({
                        text: 'Error updating template default settings',
                    });
                } finally {
                    this.busy = false;
                }
            },
            togglePerPersonRates() {
                this.formData.use_per_person_rates = !this.formData.use_per_person_rates;
                this.onFormUpdated();
            },
            toggleArrivalDayRules() {
                this.formData.arrival_day_rule_enabled = !this.formData.arrival_day_rule_enabled;
                this.onFormUpdated();
            },
            toggleDepartureDayRules() {
                this.formData.departure_day_rule_enabled = !this.formData.departure_day_rule_enabled;
                this.onFormUpdated();
            },
        },
        computed: {
            ...mapGetters('seasonality', ['templatesData']),
            options() {
                const notSet = { id: -1, name: 'Not set' };
                const templateOptions = this.templates;
                return [notSet, ...templateOptions];
            },
        },
        watch: {
            templatesData: {
                handler() {
                    if (this.templatesData) {
                        this.formData = {
                            ...this.templatesData.default_template_settings,
                        };
                    }
                },
                immediate: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    @include media-breakpoint-down(md) {
        :deep(.settings-switch .v-switch-label) {
            font-size: 14px !important;
        }
        :deep(.settings-switch .v-switch-button) {
            top: 3px !important;
            height: 19px !important;
        }            
    }

    :deep(.settings-switch) {
        width: 60px !important;
    }
    
    :deep(.settings-switch .v-switch-label) {
        padding-top: 3px !important;
        line-height: 18px !important;
        font-size: 14px !important;
    }

    :deep(.settings-switch .v-switch-core) {
        height: 24px !important;
    }

    :deep(.settings-switch .v-switch-button) {
        top: 3px !important;
        height: 17px !important;
        width: 17px !important;
    }    
</style>
